import { OrderItemRowResolver } from './types'

export const defaultOrderItemRowResolver: OrderItemRowResolver = item => ({
    name: item.name,
    quantity: item.quantity,
    price: item.approvedPrice,
})
